var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var EmailSubscriber = require('../../../../../include/_js/subscribe/EmailSubscriber');

        $(function () {
            function toggleLoading($loading, show) {
                $loading.toggleClass('hide', !show);
            }

            function subscriptionSuccess(isOpen) {
                var $popup = $('#bspopup');
                var url = window.app.urls.addSubscriptionSuccess;
                var $dialog = $popup.find('.modal-dialog');
                var $body = $popup.find('.modal-body');
                var $content = $popup.find('.modal-content');
                $popup.addClass('success-close').removeClass('subscribe-close request-close');
                if (!isOpen) {
                    $popup.addClass('request-helper');
                    $dialog.css('width', '570px');
                    $body.css('height', 'auto');
                    $content.addClass('transparent');
                    $body.html('<p class="text-center"><img src="/img/load.gif" style="width: 16px" /></p>');
                    $popup.modal({
                        backdrop: true,
                        show: true
                    });
                } else {
                    $body.hide();
                }
                $.get(url, {}, function (data) {
                    if (!isOpen) {
                        $body.html(data);
                    } else {
                        $body.html(data).show();
                    }
                });
            }
            $('body').on('click', '.subscribe-btn', function (e) {
                e.preventDefault();
                var $block = $(this).closest('.subscription-control');
                var $email = $block.find('.subscription-email-validate');
                var emailValue = $email.val();
                var cityId = $block.find('.subscription-city-control').val();
                var $loading = $block.find('.subscription-loading');
                var $popup = $(this).hasClass('popup-subscribe-btn');

                var subscriber = new EmailSubscriber(emailValue, cityId);

                if (!subscriber.validateEmail()) {
                    $email.focus();
                    $email.tooltip({
                        trigger: 'manual',
                        placement: 'top',
                        title: 'Введите свой e-mail!'
                    }).tooltip('show');
                    setTimeout(function () {
                        $email.tooltip('hide');
                    }, 2500);
                    return;
                }

                toggleLoading($loading, true);
                subscriber.subscribe(function (resultSubscribe) {
                    toggleLoading($loading, false);
                    if (resultSubscribe.success) {
                        subscriptionSuccess($popup);
                    } else {
                        $email.val('');
                        $email.prop('placeholder', resultSubscribe.message);
                        $email.focus();
                    }
                });
            });
        });
    }, { "../../../../../include/_js/subscribe/EmailSubscriber": 2 }], 2: [function (require, module, exports) {
        var EmailSubscriber = function () {
            function EmailSubscriber(email, cityId) {
                _classCallCheck(this, EmailSubscriber);

                /** @type {string} */
                this.email = email;

                /** @type {number} */
                this.cityId = Number(cityId);
            }

            _createClass(EmailSubscriber, [{
                key: "validateEmail",
                value: function validateEmail() {
                    return this.email !== '';
                }
            }, {
                key: "subscribe",
                value: function subscribe(callback) {
                    var resultData = {
                        success: false,
                        message: 'Произошла ошибка! Попробуйте позже.'
                    };

                    if (!this.validateEmail()) {
                        resultData.message = 'Введите свой e-mail';
                        callback(resultData);

                        return;
                    }

                    var params = {
                        email: this.email
                    };
                    if (this.cityId) {
                        params.city = this.cityId;
                    }

                    $.post(window.app.urls.addSubscription, params, function (response) {
                        if (response.success) {
                            window.tracking.setEvent('emailSubscription.subscribe');
                            resultData.success = true;
                        }
                        resultData.message = response.message;

                        callback(resultData);
                    });
                }
            }]);

            return EmailSubscriber;
        }();

        module.exports = EmailSubscriber;
    }, {}] }, {}, [1]);